import React, { useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import StudentAccommodationsWorkspace, { ACCOMMODATIONS_TITLE } from './StudentAccommodationsWorkspace';

export default function StudentAccommodationsModal({ show, onHide, ...workspaceProps }) {
  const [detailOpen, setDetailOpen] = useState(false);
  const sessionRef = useRef(workspaceProps);
  // The selected student's editor/PDF keeps its original scope until it is closed.
  if (!detailOpen) sessionRef.current = workspaceProps;
  const close = () => { if (!detailOpen) onHide?.(); };
  return <Modal show={show || detailOpen} onHide={close} fullscreen scrollable backdrop={detailOpen ? 'static' : true} keyboard={!detailOpen} enforceFocus={!detailOpen}>
    <Modal.Header closeButton={!detailOpen}><Modal.Title>{ACCOMMODATIONS_TITLE}</Modal.Title></Modal.Header>
    <Modal.Body><StudentAccommodationsWorkspace {...sessionRef.current} show={Boolean(show || detailOpen)} onBusyChange={setDetailOpen} /></Modal.Body>
    <Modal.Footer><Button variant="secondary" onClick={close} disabled={detailOpen}>Close</Button></Modal.Footer>
  </Modal>;
}
